import { useEffect, useState } from 'react'
import "./adminPage.css";
import DashboardHeader from '../dashboard/dashboardComponents/DashboardHeader'
import AdminNavbar from './AdminNavbar';
import AdminDisplay from './AdminDisplay';
import NotFound404 from '../NotFound404';
import ColorChanger from './ColorChanger';
import { adminColors } from '../../dataSets/adminColors';
import DashboardContextProvider from '../../contextApi/DashboardContext';

export default function AdminPage({admin, uid}) {
  const [adminDisplay, setAdminDisplay] = useState(()=>{
    const ad = sessionStorage.getItem("webingo_adminDisplay");
    return ad ? JSON.parse(ad) : 0;
  });
  const [currentTheme, setCurrentTheme] = useState(()=>{
    const ct = localStorage.getItem("webingo_adminColor");
    return ct ? JSON.parse(ct) : adminColors?.luxury;
  });
  useEffect(()=>{console.log("Admin: ",admin)},[])
  useEffect(()=>{sessionStorage.setItem("webingo_adminDisplay",JSON.stringify(adminDisplay))},[adminDisplay])
  useEffect(()=>{localStorage.setItem("webingo_adminColor",JSON.stringify(currentTheme))},[currentTheme])

  if(!admin||!uid) return <NotFound404/>
  return (
    <DashboardContextProvider>
      <div className='adminPage' style={{"--accent-color":currentTheme?.accent_color,"--primary-color":currentTheme?.primary_color,backgroundColor:currentTheme?.accent_color, color:currentTheme?.primary_color}}>
        <DashboardHeader header={"Admin Dashboard"} theme={currentTheme}/>
        <ColorChanger setColors={setCurrentTheme}/>
        <AdminNavbar display={adminDisplay} setDisplay={setAdminDisplay} theme={currentTheme}/>
        <AdminDisplay admin={admin} display={adminDisplay} theme={currentTheme}/>
      </div>
    </DashboardContextProvider>
  )
}
